import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedin, FaTelegram, FaTiktok } from 'react-icons/fa';
import logo from '../logo.png';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo-section">
            <img src={logo} alt="Bubbles Early Years School" className="footer-logo" />
          </div>
          <p>Play â€¢ Learn â€¢ Grow</p>
          <p>Nurturing young minds through fun and education.</p>
        </div>
        <div className="footer-section">
          <h4>Contact Us</h4>
          <p>ðŸ“§ Email: <a href="mailto:bubblesearlyyears25@gmail.com">bubblesearlyyears25@gmail.com</a></p>
          <p>ðŸ“ Visit Us: All Mart, Bisrate Gebriel, Addis Ababa</p>
          <p>ðŸ“ž Call Us: <a href="tel:+251948883388">+251 948 88 33 88</a><br /><a href="tel:+251940880055">+251 940 88 00 55</a></p>
        </div>
        <div className="footer-section">
          <h4>Follow Us</h4>
          <div className="social-links">
            <a href="https://www.facebook.com/share/1DVU9vV5Er/" title="Facebook"><FaFacebookF /></a>
            <a href="https://www.instagram.com/bubbles_early_years?igsh=dXY3dnFlcTl6ZmZw" title="Instagram"><FaInstagram /></a>
            <a href="https://t.me/Bubblesearlyyears" title="Telegram"><FaTelegram /></a>
            <a href="https://www.linkedin.com/in/bubbles-early-years-school-275583386" title="LinkedIn"><FaLinkedin /></a>
            <a href="https://tiktok.com/@bubbles.early.yea" title="TikTok"><FaTiktok /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2025. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;